import React, { useCallback } from "react";
import { maxLength } from "../../../../helpers/data-constants";
import {
  HRadio,
  HTextarea,
  passParamsThrough,
} from "../../../../validation/HForm";
import CharCount from "../../CharCount/CharCount";

export const RiskAssessment = (props) => {
  const {
    watch,
    setValue,
    descriptions,
    handleDescriptionChange,
  } = props;

  const handleRiskChange = useCallback(
    (riskType) => () => {
      if (watch(riskType) === "Низкий") {
        setValue(`${riskType}Explanation`, "");
      }
    },[]);

  const renderRiskItem = (type, label) => {
    return (
      <div className="risk-item">
        <div className="risk-label">
          <label className="form-element-label">{label}</label>
          <div className="risk-options">
            <div className="form-element-data riskAdd-modal">
              <div className="form-element-data-radios">
                <HRadio
                  h="true"
                  labels={["Низкий", "Высокий"]}
                  name={type}
                  errorClass="risks-error-message"
                  defaultCheckedLabel="Низкий"
                  onChange={handleRiskChange(type)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="textarea-container">
          <HTextarea
            h="true"
            className="input"
            rows="3"
            cols="10"
            name={`${type}Explanation`}
            placeholder="Обоснование высокой степени риска"
            onChange={handleDescriptionChange(type)}
            value={watch(`${type}Explanation`) || ""}
          />
          <CharCount
            value={descriptions[type] || watch(`${type}Explanation`) || ""}
            maxLength={maxLength.SERVICE_INFORMATION_RISK}
          />
        </div>
      </div>
    );
  };

  return passParamsThrough(
    <div className="action-section">
      <h4>
        Присвоенная степень риска (трехвекторная модель распределения рисков)
      </h4>
      {renderRiskItem("riskProfile", "Риск по профилю клиента")}
      {renderRiskItem("riskGeographic", "Риск по географическому региону")}
      {renderRiskItem("riskOperationType", "Риск по видам операций")}
      {renderRiskItem("riskFinal", "Итоговая степень")}
    </div>,
    props
  );
};
